import { render, staticRenderFns } from "./ServiceSystem.vue?vue&type=template&id=013975d9&scoped=true"
import script from "./ServiceSystem.vue?vue&type=script&lang=js"
export * from "./ServiceSystem.vue?vue&type=script&lang=js"
import style0 from "./ServiceSystem.vue?vue&type=style&index=0&id=013975d9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013975d9",
  null
  
)

export default component.exports